// /admin/v1/commerce/coupons — 券模板 list / create / issue.

import { list, post } from './client';
import type { ListResult } from './client';

export type CouponKind = 'discount' | 'free_trial' | 'diamond_gift';
export type CouponStatus = 'active' | 'paused' | 'archived';

export interface Coupon {
  id: number;
  app_id?: number | null;
  code: string;
  name: string;
  kind: CouponKind;
  value: number;
  conditions?: unknown;
  max_total_uses?: number | null;
  max_per_user: number;
  valid_from: string;
  valid_until?: string | null;
  status: CouponStatus;
  created_at: string;
  updated_at: string;
}

export interface CreateCouponInput {
  app_id?: number | null;
  code: string;
  name: string;
  kind: CouponKind;
  value: number;
  conditions?: unknown;
  max_total_uses?: number | null;
  max_per_user?: number;
  valid_until?: string | null;
  status?: CouponStatus;
}

export interface ListCouponsQuery {
  app_id?: number;
  limit?: number;
  offset?: number;
}

export function listCoupons(q: ListCouponsQuery = {}): Promise<ListResult<Coupon>> {
  return list<Coupon>('/admin/v1/commerce/coupons', q);
}

export function createCoupon(input: CreateCouponInput): Promise<Coupon> {
  return post<Coupon>('/admin/v1/commerce/coupons', input);
}

export interface IssueCouponsInput {
  user_ids?: string[];
  min_ltv_cents?: number;
  app_id?: number;
}

export function issueCoupons(id: number, body: IssueCouponsInput): Promise<{ issued: number }> {
  return post<{ issued: number }>(`/admin/v1/commerce/coupons/${id}/issue`, body);
}
